export class WorkflowCodesConstant {
    static readonly START_PERSON = "START_PERSON";
    static readonly START_BUSINESS = "START_BUSINESS";
    static readonly BANNO_SSO_ORIGINAL = "BANNO_SSO_ORIGINAL";
    static readonly BANNO_SSO_ORIGIN = "BANNO_SSO_ORIGIN";
    static readonly BUSINESS_CONTINUE = "BUSINESS_CONTINUE";
    static readonly CONTINUE = "CONTINUE";
    static readonly VALIDATE_TOKEN = "VALIDATE_TOKEN";
    static readonly INVITED_APPLICANTS = "INVITED_APPLICANTS";
}